import { apiClient } from './client';
import type { DockerDashboardSummary } from '../types';

export const dockerApi = {
  async getSummary(): Promise<DockerDashboardSummary> {
    const { data } = await apiClient.get<DockerDashboardSummary>('/docker/summary');
    return data;
  },
};
